<template>
  <div class="navMenuWarp">
    <div class="navCenter">
      <div class="centerLeftBox">
        <img src='@/assets/imgs/home/logo.png' />
      </div>
      <div class="centerRightBox">
        <div class="search-box">
          <!-- <input type="text" v-model="msg"> -->
          <!-- <el-input type="text" v-model="searchVal" placeholder="请输入搜索内容" @keydown.enter.native="serchEnterFn" class="input-with-select">
          </el-input> -->
          <!-- <img src='@/assets/imgs/home/searchicon.png' @click.stop="searchFn" /> -->
          <el-input type="text" v-model="searchVal" placeholder="请输入搜索内容" @keydown.enter.native="serchEnterFn" class="input-with-select">
            <el-button slot="append" icon="el-icon-search" @click="btnsearch"></el-button>
          </el-input>
        </div>
        <!-- <div class="aplymemberbox" @click="goapplymember" v-if="audit!=1">
          <img src='@/assets/imgs/home/membericon.png' />
          <span>申请入会</span>
        </div> -->
        <!-- <div class="accountbox" @click="goaccountFn" v-if="islogin">
          <img :src='headerImg?srcUrl+headerImg:accounticon' class='logoImg' />
          <span>账户中心</span>
        </div> -->
        <div class="accountbox" @click="goaccountFn" v-if="islogin">
          <img :src='headerImg?srcUrl+headerImg:accounticon' class='logoImg' />
          <span>账户中心</span>
        </div>
        <div class="handlebox" v-else>
          <div class="accountbox" @click="gologinFn">
            <!-- <img src='@/assets/imgs/nav/loginicon.png' /> -->
            <span>登录</span>
          </div>
          <div class="accountbox regist" @click="goregistFn">
            <!-- <img src='@/assets/imgs/nav/registicon.png' /> -->
            <span>注册</span>
          </div>
        </div>
      </div>
    </div>
    <div style="background: linear-gradient(180deg, #4d99ff 0%, #1d5dd6 100%);">
      <div class="nav-menubox">
        <div class="menuWarp">
          <div :class="{
            'currentMenu-box':
              currentMenu == item.title || hoverMenu == item.title,
          }" class="menu-box" v-for="item in menuData" :key="item.id" @click="clickMenuFn($event, item)">
            <div class="menu-name" :data-logo="item.logo">
              <img :src='item.imgurl' v-if="item.imgurl" />
              <div>{{ item.title }}</div>
              <!-- v-if="item.childMenu" -->
              <div class="trianglebox"></div>
            </div>
            <span class="child-menubox" v-if="item.childMenu">
              <span v-for="(ele, index) in item.childMenu" :key="index" @click="clickChildMenuFn(ele, item)" :class="currentChildMenu == ele.title?'activechild-menu-title':'child-menu-title'">
                <span class="childnameBox">
                  {{ ele.title }}
                </span>
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script >
import { httpService, srcUrl } from "@/service/httpService";
export default {
  props: {
    fatherMenu: String,
    tokenText:String,
  },
  data() {
    return {
      srcUrl: srcUrl,
      topNavList: [
        { name: '登录', icon: require("@/assets/imgs/nav/loginicon.png"), url: '/login' },
        { name: '注册', icon: require("@/assets/imgs/nav/registicon.png"), url: '/regist' },
        { name: '微信', icon: require("@/assets/imgs/nav/wecharticon.png"), url: '/login' },
      ],
      menuData: [
        { title: "首页", linkUrl: "/", },
        {
          title: "新闻中心",
          // linkUrl: "/news",
          linkUrl: "/news-secondpage/notice",
          childMenu: [
            {
              title: "通知公告",
              id: "51",
              linkUrl: "/news-secondpage/notice",
            },
            {
              title: "时政要闻",
              id: "52",
              linkUrl: "/news-secondpage/politics",
            },
            {
              title: "行业动态",
              id: "53",
              linkUrl: "/news-secondpage/industry-dynamics",
            },
            // {
            //   title: "协会动态",
            //   id: "24",
            //   linkUrl: "/news-secondpage/trends",
            // },
          ],
        },
        {
          title: "党建工作",
          // linkUrl: "/party-cloum",
          linkUrl: "/party-secondpage/party-leads",
          childMenu: [
            {
              title: "党建引领",
              id: "61",
              linkUrl: "/party-secondpage/party-leads",
            },
            {
              title: "党建动态",
              id: "62",
              linkUrl: "/party-secondpage/party-dynamic",
            },
            {
              title: "学习园地",
              id: "63",
              linkUrl: "/party-secondpage/study-section",
            },
            {
              title: "会员党建",
              id: "64",
              linkUrl: "/party-secondpage/party-member",
            },
          ],
        },
        {
          title: "行业服务",
          // linkUrl: "/industry-service",
          linkUrl: "/industry-secondpage/mark-build",
          childMenu: [
            {
              title: "团标建设",
              id: "41",
              linkUrl: "/industry-secondpage/mark-build",
            },
            {
              title: "标准动态",
              id: "42",
              linkUrl: "/industry-secondpage/standard-dynamic",
            },
            {
              title: "调查研究",
              id: "43",
              linkUrl: "/industry-secondpage/investigate",
            },
            // {
            //   title: "专家库",
            //   id: "44",
            //   linkUrl: "/industry-secondpage/experts-think",
            // },
          ],
        },
        {
          title: "会员服务",
          linkUrl: "/member-service",
          childMenu: [
            {
              title: "会员名录",
              id: "21",
              linkUrl: "/member-secondpage/member",
            },
            {
              title: "会员风采",
              id: "22",
              linkUrl: "/member-secondpage/member-style",
            },
            {
              title: "赋能会员",
              id: "23",
              linkUrl: "/member-secondpage/energize-member",
            },
          ],
        },
        {
          title: "培训服务",
          linkUrl: "/train-service",
          // childMenu: [
          //   {
          //     title: "领军人才",
          //     id: "71",
          //     linkUrl: "/leade-talent",
          //   },
          //   {
          //     title: "培训报名",
          //     id: "72",
          //     linkUrl: "/tarin-secondpage/tarin-course",
          //   },
          //   {
          //     title: "培训通知",
          //     id: "73",
          //     linkUrl: "/tarin-secondpage/tarin-inform",
          //   },
          //   // {
          //   //   title: "精选课程",
          //   //   id: "74",
          //   //   linkUrl: "/tarin-secondpage/choiceness-course",
          //   // }
          //   {
          //     title: "课程培训",
          //     id: "74",
          //     linkUrl: "/tarin-secondpage/tripartite-train",
          //   },
          // ]
        },
        {
          title: "会议活动",
          // linkUrl: "/meet-activity",
          linkUrl: "/meet-secondpage/meetactive",
          childMenu: [
            {
              title: "会议活动",
              id: "31",
              linkUrl: "/meet-secondpage/meetactive",
            },
            {
              title: "品牌活动",
              id: "32",
              linkUrl: "/meet-secondpage/brand-active",
            },
          ]
        },
        { title: "专家库", linkUrl: "/experts-think", },
        {
          title: "协会概况",
          linkUrl: "/association-profile/introduct",
          childMenu: [
            {
              title: "协会简介",
              id: "11",
              linkUrl: "/association-profile/introduct",
            },
             {
              title: "历任会长",
              id: "12",
              linkUrl: "/association-profile/past-presidents",
            },
            {
              title: "协会领导",
              id: "13",
              linkUrl: "/association-profile/association-leader",
            },
            {
              title: "组织机构",
              id: "14",
              linkUrl: "/association-profile/organization",
            },
            {
              title: "协会章程",
              id: "15",
              linkUrl: "/association-profile/association-charter",
            },
            {
              title: "服务目录",
              id: "16",
              linkUrl: "/association-profile/service-catalog",
            },
          ]
        },
        {
          title: "分支机构",
          linkUrl: "/branch",
        },
        {
          title: "能力指数测评",
          linkUrl: "/assessment-institutions",
          // imgurl: require("@/assets/imgs/nav/icon.png"),
        },
      ],
      currentMenu: "首页",
      // 搜索
      searchFlag: false,
      currentChildMenu: null,
      searchVal: "",
      hoverMenu: "",
      menuFlag: true,
      islogin: sessionStorage.getItem('token'),
      audit: sessionStorage.getItem('audit'),
      auditObj: {},
      userId: '',
      accounticon: require("@/assets/imgs/home/accounticon.png"),
      headerImg: sessionStorage.getItem('headerImg') || null,
    };
  },
  watch: {
  	tokenText: {
  		handler(val) {
        if (val) {
          this.islogin=val
        }
  		},
  		deep: true, // 深度监听
  		immediate: true, // 初次监听即执行
  	},
  },
  beforeMount() {
    let clickMenu = sessionStorage.getItem("clickMenu");
    this.currentMenu = clickMenu;
  },
  mounted() {
    if (JSON.parse(sessionStorage.getItem('userInfo'))) {
      this.userId = JSON.parse(sessionStorage.getItem('userInfo')).userId
    }
    // 会员状态
    // console.log(this.islogin&&this.currentMenu!='能力指数测评',"this.islogin&&this.currentMenu!='能力指数测评'");
    if (this.islogin && this.audit != 1) {
      this.getAuditFn()
    } else {
      this.$emit('memberAudit', this.audit)
      // console.log(sessionStorage.getItem('headerImg'));
    }
  },
  methods: {
    getAuditFn() {
      httpService.getCorpInfoOther(this.userId).then(res => {
        // 99保存 0提交审核中 1通过 2审核失败
        if (res.code == 200) {
          if (res.result) {
            // this.auditObj = res.result
            this.audit = res.result.audit
            this.headerImg = res.result.logo
            sessionStorage.setItem('audit', res.result.audit)
            if (res.result.logo == null || res.result.logo == '') {
              return;
            }
            sessionStorage.setItem('headerImg', res.result.logo)
          }
          this.$emit('memberAudit', res.result.audit)
        }
      })
    },
    clickMenuFn(e, val) {
      // 清楚二级页面点击菜单
      sessionStorage.removeItem('currentNew')
      sessionStorage.removeItem("site");
      if (e.target.nodeName == "DIV" || e.target.dataset.logo == "one") {
        // if (val.title == "业务平台") {
        //   this.currentMenu = "首页";
        //   sessionStorage.setItem("clickMenu", "首页");
        //   sessionStorage.setItem("hashId", "#2");
        //   this.$bus.$emit("cli");
        //   this.$router.push({
        //     path: val.linkUrl,
        //   });
        // } else if (val.title == "党的建设") {
        //   sessionStorage.setItem("clickMenu", val.title);
        //   this.currentMenu = val.title;
        //   this.$router.push({
        //     path: val.linkUrl,
        //     query: {
        //       name: "党建工作",
        //     },
        //   });
        // } else {
        // 清除子菜单
        sessionStorage.removeItem("childMenuObj");
        sessionStorage.setItem("clickMenu", val.title);
        sessionStorage.setItem("fatherlinkUrl", val.linkUrl);
        this.currentMenu = val.title;
        this.$router.push({
          path: val.linkUrl,
        });
        // }
      }

    },
    clickChildMenuFn(data, fatherData) {
      // if (data.title == "管理咨询") {
      //   sessionStorage.setItem("clickMenu", "业务平台");
      //   this.currentMenu = "业务平台";
      //   this.$router.push({
      //     path: data.linkUrl,
      //   });
      // } else {
      this.currentMenu = fatherData.title;
      this.currentChildMenu = data.title;
      sessionStorage.setItem('clickMenu', fatherData.title)
      sessionStorage.setItem("childMenuObj", JSON.stringify(data));
      this.$router.push({
        path: data.linkUrl,
      });
      // }
    },
    // showDialog(val) {
    //   this.hoverMenu = val.title;
    // },
    // leavephoneFn(val) {
    //   console.log(val,'移出')
    //   this.hoverMenu == null;
    // },
    clickSearch() {
      this.searchFlag = true;
    },
    searchFn() {
      if (this.searchVal) {
        sessionStorage.setItem("searchVal", this.searchVal);
        let clickMenu = sessionStorage.getItem('clickMenu')
        if (clickMenu != '首页') {
          this.currentMenu = "首页";
          sessionStorage.setItem("clickMenu", "首页");
        }
        // this.$router.push({name: "SearchPage"});
        this.$router.push({
          path: '/search',
          query: {
            val: this.searchVal
          }

        });
        this.searchVal = null
      } else {
        // this.$message('请输入搜索内容')
        this.searchFlag = false;
      }
    },
    serchEnterFn(e) {
      let keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.searchFn();
      }
    },
    btnsearch() {
      this.searchFn();
    },
    jumpFn(item) {
      if (item.name == '登录' || item.name == '注册') {
        sessionStorage.clear()
      }
      this.$router.push(item.url);
    },
    goaccountFn() {
      if (this.islogin) {
        this.$router.push('/account-center');
      } else {
        this.$message({
          message: '请先登录网站',
          type: 'warning'
        });
      }
    },
    gologinFn() {
      this.$router.push('/login');
      sessionStorage.clear()
    },
    goregistFn() {
      this.$router.push('/regist');
      sessionStorage.clear()
    },
    goapplymember() {
      if (this.islogin) {
        this.$router.push('/account-center/member-ship')
      } else {
        this.$message({
          message: '请先登录网站',
          type: 'warning'
        });
      }

    },
    // gohelpFn() {
    //   this.$router.push('/help');
    // }
  },
};
</script>
<style scoped lang="less">
//     .widthnav-menubox{transition: width 1.5s linear; width: 220px;}
//     .nav-menubox:hover{
//     width: 200px;
//     transition:width 1.5s linear;
// }
.navMenuWarp {
	width: 100%;
	margin: 0 auto;
	background: #fff;
	// box-shadow: 0px 3px 12px 1px rgba(0, 0, 0, 0.16);
	.navTopBox {
		height: 56px;
		background: rgba(230, 240, 255, 0.39);
		padding: 0 290px;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		.topleftbox {
			display: flex;
			flex-direction: row;
			// align-items: center;
			.handlebox {
				display: flex;
				flex-direction: row;
				align-items: center;
				margin-right: 27px;
				cursor: pointer;
				span {
					display: inline-block;
					font-size: 16px;
					color: #448df7;
					margin-left: 4px;
				}
			}
		}
		.toprightbox {
			display: flex;
			flex-direction: row;
			align-items: center;
			cursor: pointer;
			span {
				font-size: 16px;
				line-height: 35px;
				color: #448df7;
				margin-left: 4px;
			}
			.line {
				margin: 0 22px;
				width: 1px;
				height: 20px;
				background: rgba(153, 153, 153, 0.49019607843137253);
			}
			.helpBox {
				display: flex;
				flex-direction: row;
				align-items: center;
				cursor: pointer;
				img {
					width: 17.33px;
					height: 17.33px;
					margin-top: 4px;
				}
			}
		}
	}
	.navCenter {
		width: 1200px;
		margin: 0 auto;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		padding: 0px 10px 0px 10px;
		align-items: center;
		// height: 96px;
		height: 86px;
		box-sizing: border-box;
		.centerLeftBox {
			width: 494px;
			height: 68px;
		}
		.centerRightBox {
			display: flex;
			flex-direction: row;
			align-items: center;
			text-align: right;
			// 搜索框
			.search-box {
				// background: #1088fe;
				width: 266px;
				justify-content: center;
				align-items: center;
				align-content: center;
				text-align: center;
				// padding: 30px 0px;
				height: 40px;
				display: flex;
				flex-direction: row;
				margin-right: 36px;
				position: relative;
				/deep/.el-input__inner {
					// background-color: #68b4ff;
					border: 1px solid #1875d9;
					border-right: none;
					border-radius: 0px;

					// padding:
					// color: #000 !important;
					// border-radius: 20px;
				}
				// /deep/input::placeholder {
				// 	color: #cacaca !important;
				// }
				// img {
				// 	position: absolute;
				// 	// height: 40px;
				// 	// width: 40px;
				// 	right: 5px;
				// }
				/deep/.el-icon-search {
					color: #fff;
				}
				/deep/.el-button {
					height: 40px;
					background: #1875d9;
					// border: 1px solid #1875d9;
					border-radius: 0px;
				}
				/deep/.el-input-group__append,
				.el-input-group__prepend {
					padding: 0;
				}
			}
			.handlebox {
				display: flex;
				flex-direction: row;
				align-items: center;
			}
			.accountbox,
			.aplymemberbox {
				height: 24px;
				line-height: 24px;
				display: flex;
				flex-direction: row;
				align-items: center;
				cursor: pointer;
				margin-left: 10px;
				span {
					display: inline-block;
					font-size: 16px;
					color: #333333;
					margin-left: 10px;
				}
			}
			.regist {
				border-left: 1px solid rgba(153, 153, 153, 0.49019607843137253);
			}
			.logoImg {
				width: 30px;
				height: 30px;
				border-radius: 50%;
			}
			.aplymemberbox {
				margin: 0 0px 0 33px;
				padding-right: 21px;
				border-left: 1px solid rgba(153, 153, 153, 0.49019607843137253);

				span {
					color: #ffce48;
				}
			}
		}
	}
	.nav-menubox {
		// width: 1200px;
width: 1296px;
		// padding: 0 8px 0 12px;
		box-sizing: border-box;
		margin: 0 auto;
		height: 100%;
		display: flex;
		flex-direction: row;
		background: linear-gradient(180deg, #4d99ff 0%, #1d5dd6 100%);
		font-size: 18px;
		position: relative;
		// border-right: 5px solid #d60029;
		.menuWarp {
			display: flex;
			flex-direction: row;
			align-items: center;
		}
		.menu-box:hover {
			// color: #1088fe;
			.trianglebox  {
				display: block;
			}
			.child-menubox {
				position: absolute;
				// width: 200px;
				// padding: 20px 30px;
				left: -18%;
				display: flex;
				flex-direction: column;
				display: none;
				// background: #1256d1;
				width: 132px;
				background: rgba(30, 80, 174, 0.39);
				display: block;
				// float: left;
			}
		}
		.menu-box {
			color: #fff;
			// font-size: 22px;
			font-weight: bold;
			text-align: center;
			margin: 0 15px;
			height: 48px;
			line-height: 48px;
			// position: relative;
			min-width: 75px;
			position: relative;
			padding: 0 6px;
			&:first-child {
				min-width: 48px;
				margin-left: 0;
			}
			&:last-child {
				// font-size: 16px;
				line-height: 39px;
				color: #ffffff;
				width: 140px;
				margin-right: 0px;

				.menu-name {
					padding: 4px 0;
				}
				// padding: 10px 0;
			}
			.menu-name {
				// width: 6vw;
				display: flex;
				flex-direction: row;
				justify-content: center;
				align-items: center;
				// margin: 0 20px 0 20px;
				cursor: pointer;
				position: relative;
				img {
					width: 26px;
					height: 30px;
				}
			}
			.trianglebox  {
				position: absolute;
				bottom: 0px;
				left: 50%;
				transform: translateX(-50%);
				width: 36px;
				height: 2px;
				background: #fff;
				// width: 0;
				// height: 0;
				// border-left: 8px solid transparent;
				// border-right: 8px solid transparent;
				// border-bottom: 9px solid #3a9dff;
				display: none;
			}
		}
		// 点击之后的样式
		.currentMenu-box {
			// background: #d60029;
			background: #1256d1;
			padding: 0 6px;
			cursor: pointer;
			.trianglebox  {
				display: block;
			}
			.menu-name {
				// width: 100px;

				// margin: 0 15px 0 15px;
				cursor: pointer;
			}
		}

		.search-linbox {
			width: 3px;
			background-color: #000;
			height: 30px;
			margin: auto 10px auto 14px;
		}
		.el-icon-search {
			font-size: 20px;
		}
		.child-menubox {
			position: absolute;
			left: -18%;
			display: flex;
			flex-direction: column;
			display: none;
			width: 132px;
			display: none;
			z-index: 99;
			padding: 12px 0 20px 0;
			font-size: 16px;
			font-weight: 400;
			.child-menu-title {
				display: inline-block;
				width: 132px;
				// padding: 10px 0px;
				color: #fff;
				cursor: pointer;
				&:hover {
					background: #1256d1;
					// padding: 30px;
				}
			}
			.activechild-menu-title {
				display: inline-block;
				width: 132px;
				background: #1256d1;
			}
		}
		// .child-menubox {
		// 	position: absolute;
		// 	// width: 200px;
		//   padding: 20px 30px;
		//   left: -18%;
		// 	display: flex;
		// 	flex-direction: column;
		// 	display: none;
		//   // background: #1256d1;
		//   width: 72px;
		// }
	}
}
</style>